import styled, { css, keyframes, RuleSet } from "styled-components";
import { darkGreen, lightGreys } from "../../styles";
import { pulse } from "../containers/styledComponents";
import { ProgressBar } from "react-bootstrap";

export const CompassParagraph = styled.p<{
  bold?: boolean;
  fontSize?: number;
  underline?: boolean;
  hoverUnderline?: boolean;
  color?: string;
  ml?: number;
  mr?: number;
  mt?: number;
  mb?: number;
  display?: string;
  ta?: string;
  cursor?: string;
  ws?: string;
  lh?: number;
}>`
  font-family: ${({ bold }): string => (bold ? "ApercuMedium" : "Apercu")};
  font-size: ${({ fontSize }): number => fontSize || 13}px;
  ${({ lh }): string | undefined | 0 => lh && `line-height: ${lh};`}
  margin-right: ${({ mr }): number => mr || 10}px;
  margin-left: ${({ ml }): number => ml || 0}px;
  margin-top: ${({ mt }): number => mt || 0}px;
  margin-bottom: ${({ mb }): number => mb || 0}px;
  text-decoration: ${({ underline }): string =>
    underline ? "underline" : "none"};
  color: ${({ color }): string => color || "black"};
  display: ${({ display }): string => display || "block"};
  text-align: ${({ ta }): string => ta || "left"};
  white-space: ${({ ws }): string => ws || "normal"};
  cursor: ${({ cursor }): string => cursor || "default"};

  &:hover {
    text-decoration: ${({ hoverUnderline }): string =>
      hoverUnderline ? "underline" : "none"};
    text-decoration-color: ${({ color }): string => color || "currentcolor"};
  }
`;

export const TextBox = styled.div<{ isLoading?: boolean; mr?: number }>`
  display: flex;
  flex-grow: 1;
  justify-content: flex-start;
  align-items: flex-start;
  min-height: 40px;
  max-height: 400px;
  padding: 10px; 15px;
  border-radius: 8px;
  border: 1px solid ${lightGreys.borderLightGrey};
  margin-right: ${({ mr }): number => mr || 15}px;
  word-wrap: break-word;
  overflow-y: auto;
  background-color: ${({ isLoading }): string =>
    isLoading ? "#D3D3D3" : "white"};
  opacity: ${({ isLoading }): string => (isLoading ? "0.5" : "1")};
  ${({ isLoading }): false | RuleSet<object> | undefined =>
    isLoading &&
    css`
      animation: ${pulse} 1.5s cubic-bezier(0.4, 0, 0.6, 1) infinite;
    `}
  `;

export const CompassInput = styled.input<{
  bold?: boolean;
  fontSize?: number;
  underline?: boolean;
  color?: string;
  ml?: number;
  mr?: number;
  mt?: number;
  mb?: number;
  display?: string;
  ta?: string;
  ws?: string;
}>`
  font-family: ${({ bold }): string => (bold ? "ApercuMedium" : "Apercu")};
  font-size: ${({ fontSize }): number => fontSize || 13}px;
  margin-right: ${({ mr }): number => mr || 10}px;
  margin-left: ${({ ml }): number => ml || 0}px;
  margin-top: ${({ mt }): number => mt || 0}px;
  margin-bottom: ${({ mb }): number => mb || 0}px;
  text-decoration: ${({ underline }): string =>
    underline ? "underline" : "none"};
  color: ${({ color }): string => color || "black"};
  display: ${({ display }): string => display || "block"};
  text-align: ${({ ta }): string => ta || "left"};
  white-space: ${({ ws }): string => ws || "normal"};
`;

export const CompassTextarea = styled.textarea<{
  bold?: boolean;
  h?: string;
  fontSize?: number;
  underline?: boolean;
  color?: string;
  ml?: number;
  mr?: number;
  mt?: number;
  mb?: number;
  display?: string;
  ta?: string; // text-align
  cursor?: string;
  ws?: string; // white-space
  isLoading?: boolean;
}>`
  display: flex;
  flex: 1;
  height: ${({ h }): string => h || "200px"};
  font-family: ${({ bold }): string => (bold ? "ApercuMedium" : "Apercu")};
  font-size: ${({ fontSize }): number => fontSize || 13}px;
  margin-right: ${({ mr }): number => mr || 10}px;
  margin-left: ${({ ml }): number => ml || 0}px;
  margin-top: ${({ mt }): number => mt || 0}px;
  margin-bottom: ${({ mb }): number => mb || 0}px;
  text-decoration: ${({ underline }): string =>
    underline ? "underline" : "none"};
  color: ${({ color }): string => color || "black"};
  padding: 10px; 15px;
  border-radius: 8px;
  border: 1px solid ${lightGreys.borderLightGrey};
  display: ${({ display }): string => display || "block"};
  text-align: ${({ ta }): string => ta || "left"};
  white-space: ${({ ws }): string => ws || "normal"};
  max-height: 400px;
  min-height: 120px;
  background-color: ${({ isLoading }): string =>
    isLoading ? "#D3D3D3" : "white"};
  opacity: ${({ isLoading }): string => (isLoading ? "0.5" : "1")};
  ${({ isLoading }): false | RuleSet<object> | undefined =>
    isLoading &&
    css`
      animation: ${pulse} 1.5s cubic-bezier(0.4, 0, 0.6, 1) infinite;
    `}
`;

export const StyledAnchor = styled.a<{
  hoverUnderline?: boolean;
  color?: string;
}>`
  color: ${({ color }): string => color || darkGreen};
  text-decoration: none;

  &:hover {
    text-decoration: ${({ hoverUnderline }): string =>
      hoverUnderline ? "underline" : "none"};
    text-decoration-color: ${({ color }): string => color || "currentcolor"};
  }
`;

export const CompassHeader = styled.h1`
  font-family: "ApercuBold";
  margin-bottom: 30px;
`;

export const CompassMainHeader = styled.p<{ pt?: number; ml?: number }>`
  margin-bottom: 0px;
  margin-left: ${({ ml }): number => ml || 0}px;
  padding-top: ${({ pt }): number => pt || 15}px;
  font-size: 24px;
  font-family: "ApercuBold";
  color: ${darkGreen};
`;

//Animations
// Keyframe animation for the "pop" effect
export const popAnimation = keyframes`
  0% {
    transform: translateY(20px);
    opacity: 0;
  }
  100% {
    transform: translateY(0);
    opacity: 1;
  }
`;

export const boxShadow = "0px 2px 4px rgba(0, 0, 0, 0.1)";

export const VotingAlignmentBar = styled(ProgressBar)<{
  barHeight?: number;
  w?: string;
}>`
  height: ${({ barHeight }): number => barHeight || 8}px;
  width: ${({ w }): string => w || "85%"};
  background-color: transparent;
`;
